import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-auto-temporaire',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-auto-temporaire.component.html',
  styleUrls: ['./assurance-auto-temporaire.component.scss']
})
export class AssuranceAutoTemporaireComponent {
  title = 'Assurance Auto Temporaire';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/auto-peso.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Auto Temporaire', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Moto Personnelle',
    link: '/assurance-moto-personnelle'
  };

  nextPage = { 
    title: 'Assurance Multirisque Immeuble - MRI - PNO',
    link: '/assurance-multirisque-immeuble-pno'
  };

  // Partners logos for carousel
  partners = [
    { name: 'J.Lassur', logo: 'assets/logos/jlassur.png' },
    { name: 'Netvox', logo: 'assets/logos/netvox.png' },
    { name: 'Generali', logo: 'assets/logos/GENERALI.PNG' },
    { name: 'April', logo: 'assets/images/logos/april-logo.png' },
    { name: 'Swiss Life', logo: 'assets/logos/SWISSLIFE.PNG' },
    { name: 'Zephir', logo: 'assets/logos/zephir.png' },
    { name: 'Novelia', logo: 'assets/logos/novelia.png' },
    { name: 'FMA', logo: 'assets/logos/fma.png' }
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
